// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import requestAnswerEntity from './entities/request-answer.json';
import requestAnswerMenu from '../pages/request-answer/menu.json';
import requestAnswerFullForm from '../pages/request-answer/forms/full.json';
import requestAnswerContextForm from '../pages/request-answer/forms/context.json';
import requestAnswerMiniForm from '../pages/request-answer/forms/mini.json';
import requestAnswerLookupForm from '../pages/request-answer/forms/lookup.json';
import requestAnswerTableView from '../pages/request-answer/views/table.json';
import requestAnswerCardsView from '../pages/request-answer/views/cards.json';
import requestAnswerCalendarView from '../pages/request-answer/views/calendar.json';
import requestAnswerDashboardView from '../pages/request-answer/views/dashboard.json';

/** Тип запису «Відповідь на запит» зі сторінками пакета: меню, форми та подання з pages/request-answer/. */
export const requestAnswerDefinition: IRecordTypeDefinition = {
  ...requestAnswerEntity,
  views: assembleViewSet({
      table: requestAnswerTableView,
      cards: requestAnswerCardsView,
      calendar: requestAnswerCalendarView,
      dashboard: requestAnswerDashboardView,
  }),
  form: requestAnswerFullForm,
  forms: { full: requestAnswerFullForm, context: requestAnswerContextForm, mini: requestAnswerMiniForm, lookup: requestAnswerLookupForm },
  menu: requestAnswerMenu,
} as IRecordTypeDefinition;
